import type { MonthPickerDate } from '@/stores/store_chart'

export function getMonthInterval(date: Date): { first: string; last: string } {
  const year = date.getFullYear()
  const month = date.getMonth()
  const firstDayOfMonth = new Date(year, month, 1)
  const lastDayOfMonth = new Date(year, month + 1, 0)
  const firstDayString = getDateStringYMD(firstDayOfMonth)
  const lastDayString = getDateStringYMD(lastDayOfMonth)

  return {
    first: firstDayString,
    last: lastDayString
  }
}

export function getDateStringYMD(date: Date | { year: number; month: number }, last?: boolean) {
  if (!date) return ''

  if (date instanceof Date) {
    if (last) {
      return `${date.getFullYear()}-${f0(date.getMonth() + 1)}-${f0(date.getDate())}T23:59:59.99Z`
    } else {
      return `${date.getFullYear()}-${f0(date.getMonth() + 1)}-${f0(date.getDate())}`
    }
  } else {
    if (last) {
      var last_day = new Date(date.year, date.month + 1, 0)
      return `${last_day.getFullYear()}-${f0(last_day.getMonth() + 1)}-${f0(last_day.getDate())}T23:59:59.99Z`
    } else {
      var last_day = new Date(date.year, date.month, 1)
      return `${last_day.getFullYear()}-${f0(last_day.getMonth() + 1)}-1`
    }
  }
}

function f0(n: number) {
  if (n < 10) {
    return `0${n}`
  }

  return n.toString()
}

export function normalizeMonthPickerDate(date?: { month: number; year: number }) {
  if (date === undefined) {
    return new Date()
  }
  return new Date(date.year, date.month, 1)
}

export function toDate(input: Date | MonthPickerDate): Date {
  if (input instanceof Date) {
    return new Date(input.getFullYear(), input.getMonth(), 1)
  }

  return new Date(input.year, input.month, 1)
}

export function getMonthNames(locales: string | string[]): string[] {
  const formatter = new Intl.DateTimeFormat(locales, { month: 'long' })
  return Array.from({ length: 12 }, (_, i) => {
    const date = new Date(2000, i, 1)
    const datestring = formatter.format(date)
    return datestring.charAt(0).toUpperCase() + datestring.slice(1)
  })
}

export function getMonthsBetween(
  startDate: Date | MonthPickerDate,
  endDate: Date | MonthPickerDate
): string[] {
  const start = toDate(startDate)
  const end = toDate(endDate)
  const result: string[] = []
  const months = getMonthNames('fr-FR')
  const current = new Date(start.getFullYear(), start.getMonth(), 1)

  if (start === end) {
    const month = current.getMonth()
    result.push(months[month] + ' ' + current.getFullYear())
    return result
  }

  while (current <= end) {
    const month = current.getMonth()
    result.push(months[month] + ' ' + current.getFullYear())
    current.setMonth(current.getMonth() + 1)
  }

  return result
}
